export default "__VITE_ASSET__KU9AGRxF__"